import { createUseStyles } from 'react-jss';

export const getJobReportStyles = createUseStyles({
  container: {

  },
});
